import { colorEfectivo } from "@/utils/calendarioUtils";

export const presupuesto = [
  {
    label: "Id",
    name: "idpresupuesto",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Obra",
    name: "idobra",
    type: "obra",
    showOnList: true,
  },
  {
    label: "Estado",
    name: "estado",
    type: "STRINGINLIST",
    showOnList: true,
    options: ["Approved", "Rejected", "Waiting", "Finalized"],
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
    colorFila: colorEfectivo,
  },
  {
    // 12.3.a: color de los registros de este proyecto en el calendario
    label: "Color en el calendario",
    name: "color",
    type: "COLOR",
    allowNull: true,
  },
  {
    label: "Fecha del Costo",
    name: "fecha_costo_engapa",
    type: "DATE",
    allowNull: true,
    showOnList: true,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Costo del proyecto",
    name: "costo_engapa",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    step: 0.01,
    readonly: true,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Cobrado",
    name: "cobrado",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    step: 0.01,
    readonly: true,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Monto total comparativo (USD)",
    name: "monto_total_comparativo",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    step: 0.01,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Monto total",
    name: "monto_total",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Monto horas redibujo",
    name: "monto_horas_redibujo",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Monto asesoramiento",
    name: "monto_asesoramiento",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    roles: ["admin"],
    currency: true,
  },
  {
    label: "Moneda",
    name: "idmoneda",
    type: "moneda",
    roles: ["admin"],
  },
  {
    label: "Área de intervención en m2",
    name: "area_intervencion",
    type: "INTEGER",
    allowNull: true,
  },
  {
    label: "Volumen (m3)",
    name: "volumen",
    type: "INTEGER",
    allowNull: true,
  },
  {
    label: "Fecha envío",
    name: "fecha_enviado",
    type: "DATE",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Fecha inicio",
    name: "fecha_inicio",
    type: "DATE",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Fecha fin",
    name: "fecha_fin",
    type: "DATE",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Indice 1 (rentabilidad)",
    name: "indice1",
    type: "DECIMAL",
    allowNull: true,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Indice 2 (% cobrado)",
    name: "indice2",
    type: "DECIMAL",
    allowNull: true,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Indice 3 (USD/m2)",
    name: "indice3",
    type: "DECIMAL",
    allowNull: true,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Indice 4 (hs/m3)",
    name: "indice4",
    type: "DECIMAL",
    allowNull: true,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Costo total horas",
    name: "costo_total_horas",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    step: 0.01,
    readonly: true,
    roles: ["admin"],
  },
  {
    label: "Costo hora promedio",
    name: "costo_hora_promedio",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    step: 0.01,
    readonly: true,
    roles: ["admin"],
  },
];
